var unitPrice = "{{ pricePerUnit }} pro Einheit";
var unitsCount = "{{ unitsCount }} Stück";
var unitCount = "{{ unitsCount }} Stück";
var unitPriceWithQuantity = "{{ unitsCount }} Stück à {{ pricePerUnit }}";
var vatInclusive = "Inkl. MwSt.";
var vatExclusive = "Zzgl. MwSt.";
var excludeShipping = "Zzgl. {{ shipping }}";
var includeShipping = "Inkl. {{ shipping }}";
var shipping = "Lieferung";
var vatAndShipping = {
	includeVatExcludeShipping: "Inkl. MwSt., zzgl. {{ shipping }}",
	excludeVatIncludeShipping: "Zzgl. MwSt., inkl. {{ shipping }}",
	includeVatIncludeShipping: "Inkl. MwSt., inkl. {{ shipping }}",
	excludeVatExcludeShipping: "Zzgl. MwSt., zzgl. {{ shipping }}"
};
var priceSummary = "Preisübersicht";
var priceSummaryInfoIcon = "Infosymbol für Preisübersicht";
var priceSummaryModal = "Modales Dialogfeld „Preisübersicht“";
var priceSummaryCloseModal = "Modales Dialogfeld „Preisübersicht“ schließen";
var priceSummaryTermsAndConditions = "* Für jeden Auftrag müssen ein Sieb oder Tampon angefertigt und die Geräte entsprechend eingestellt werden. ";
var priceSummaryBasePrice = "Grundpreis";
var priceSummarySetupFee = "Bearbeitungskosten*";
var priceSummarySubtotal = "Zwischensumme";
var differentialPrice = {
	included: "Inklusive",
	forUnits: "{{ differentialPrice }} für {{ quantity }} Stück",
	forUnit: "{{ differentialPrice }} für {{ quantity }} Stück"
};
var priceFrom = "Ab {{ price }}";
var priceFromEach = "Ab {{ price }} pro Stück";
var volumeDiscount = "{{volumeDiscount}} % Mengenrabatt";
var volumeDiscountPlusSale = "{{volumeDiscount}} % Mengenrabatt + Sale";
var rangePrice = "{{xx}} – {{yy}}";
var unitRangePrice = "{{rangePrice}} pro Stück";
var originalPrice = "Alter Preis:";
var salePrice = "Neuer reduzierter Preis:";
var setupFee = "{{ setupFee }} Bearbeitungskosten";
var noSetupFee = "Keine Bearbeitungskosten";
var vatAndSetupFee = {
	noVatInclSetup: "Inkl. {{ setupFee }} Bearbeitungskosten",
	inclVatAndSetup: "Inkl. {{ setupFee }} Bearbeitungskosten und MwSt.",
	exclVatInclSetup: "Inkl. {{ setupFee }} Bearbeitungskosten, zzgl. MwSt.",
	inclVatSetupInclShipping: "Inkl. {{ setupFee }} Bearbeitungskosten und MwSt., inkl. {{ shipping }}",
	inclVatSetupExclShipping: "Inkl. {{ setupFee }} Bearbeitungskosten und MwSt., zzgl. {{ shipping }}",
	exclVatSetupInclShipping: "Inkl. {{ setupFee }} Bearbeitungskosten, zzgl. MwSt., inkl. {{ shipping }}",
	exclVatSetupExclShipping: "Inkl. {{ setupFee }} Bearbeitungskosten, zzgl. MwSt. und {{ shipping }}"
};
var priceFor = "{{ quantity }} für {{ price }}";
var dede = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	priceFromEach: priceFromEach,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee,
	priceFor: priceFor
};

export { dede as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFor, priceFrom, priceFromEach, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
